import type { Resource } from '../../';
export const product_tiles_bestFor: Resource = {"default":"Best For:"};
